module.exports = __webpack_public_path__ + "img/error-general.png";